import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';
import { SearchResponseCollection, SearchResponseStatus, SearchResponseTrack, SearchType } from './searchService';

export enum InspectType {
  unknown = 'unknown',
  track = 'track',
  album = 'album',
  artist = 'artist',
  playlist = 'playlist',
}

export type InspectResult<T> = {
  status: SearchResponseStatus;
  source?: MusicAPIIntegrationID;
  type: InspectType;
  data: T | null;
};

export type InspectByUrlResponse = InspectResult<SearchResponseTrack | SearchResponseCollection>;

export function inspectTypeToSearchType(inspectType: InspectType): SearchType {
  switch (inspectType) {
    case InspectType.album:
      return SearchType.album;
    case InspectType.artist:
      return SearchType.artist;
    case InspectType.track:
      return SearchType.track;
    case InspectType.unknown:
      return SearchType.unknown;
    case InspectType.playlist:
      return SearchType.unknown;
  }
}
